import type { DocMigration } from "../docMigration";

function migrateRailingSetting(setting: any, forceSetInfillStyle: boolean = false) {
  if (!setting || typeof setting !== "object") {
    return;
  }

  if (setting.infillStyle === undefined && (forceSetInfillStyle || setting.hasBalusters !== undefined)) {
    setting.infillStyle = setting.hasBalusters === false ? "NONE" : "BALUSTERS";
  }

  delete setting.hasBalusters;
}

const migration: DocMigration = {
  id: "20260220_railing_infill_style",
  description: "Replace railing hasBalusters with infillStyle",
  apply(json: any): any {
    const settingsTable = json.settings ?? {};
    for (const settingSet of Object.values(settingsTable)) {
      const setting = settingSet as { type?: string; railingSettingsTable?: Record<string, any> };
      if (setting.type !== "RAILING_CATALOG_SETTINGS") {
        continue;
      }

      const railingSettingsTable = setting.railingSettingsTable ?? {};
      for (const railingSetting of Object.values(railingSettingsTable)) {
        migrateRailingSetting(railingSetting, true);
      }
    }

    const railings = json.railings ?? {};
    for (const railing of Object.values(railings)) {
      const settingsOverride = (railing as { settingsOverride?: any }).settingsOverride;
      if (!settingsOverride || typeof settingsOverride !== "object") {
        continue;
      }
      migrateRailingSetting(settingsOverride);
    }

    return json;
  },
};

export default migration;
